/**
 * 数据字典 API（mobile 端精简版，对齐 blu-system 的 DictController）。
 *
 * 网关路由：/api/dict/** → blu-system，StripPrefix=1。
 * 后端真实端点：
 * - GET /dict/data/batch  批量拉取所有字典（前端缓存用），返回 Map<dictType, Map<dictCode, dictLabel>>
 *
 * mobile 仅消费预热缓存，不暴露 listTypes / createDict 等后台管理接口。
 */
import { request } from './request';

/** 批量字典数据：dictType → (dictCode → dictLabel) */
export type DictDataMap = Record<string, Record<string, string>>;

export function listAllDictData(): Promise<DictDataMap> {
  return request<DictDataMap>('/dict/data/batch');
}
